import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // (重寄)認證信
    resendEmail() {
      return new Promise((resolve, reject) => {
        axios('/api/user/resend', {
          method: 'POST',
          headers: {
            token: useJwt.getToken(),
          },
        })
          .then(response => { resolve(response) })
          .catch(error => reject(error))
      })
    },
  },
}
